import script from "./kucun.vue?vue&type=script&setup=true&lang=js"
export * from "./kucun.vue?vue&type=script&setup=true&lang=js"

import "./kucun.vue?vue&type=style&index=0&id=2a891168&lang=scss&scoped=true"

import exportComponent from "D:\\liu\\jmzc\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a891168"]])

export default __exports__